import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GcTextComponent } from '@ip-only/front-end-library';
import { MarkAsDoneButtonComponent } from '../components/mark-as-done-button/mark-as-done-button.component';
import { OptionsButtonComponent } from '../components/options-button/options-button.component';
import { ReportSelfInspectionWrapperComponent } from '../components/report-self-inspection-wrapper/report-self-inspection-wrapper.component';
import {
  CheckBoxInputData,
  SelfInspcetionWrapperData,
} from '../report-input-entities';
import { SelfInspectionBaseClassComponent } from '../self-inspection-base-class/self-inspection-base-class.component';

@Component({
  selector: 'app-self-inspection-checkbox',
  imports: [
    GcTextComponent,
    ReportSelfInspectionWrapperComponent,
    MarkAsDoneButtonComponent,
    OptionsButtonComponent,
  ],
  templateUrl: './self-inspection-checkbox.component.html',
  styleUrl: './self-inspection-checkbox.component.scss',
})
export class SelfInspectionCheckboxComponent<
  T,
> extends SelfInspectionBaseClassComponent<T> {
  @Input() data: CheckBoxInputData;
  @Input() wrapperData: SelfInspcetionWrapperData;

  @Output() markAsDone = new EventEmitter();

  get selfInspectionId(): string {
    return this.data.id;
  }

  handleMarkAsDone() {
    this.setIsLoadingTrue();
    this.markAsDone.emit({ checkBox: true });
  }
}
